import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi, EntiApi, UsersApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useInvitesDataSource() {
    const api = new UsersApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getInvites({ tenantId: currentTenant.Id });
          },

          remove: (key) => {
            return api.deleteInvite({
                tenantId: currentTenant.Id,
                inviteId: key
            });
          }

        });
      }, [currentTenant]);
    
      return dataSource;
}


